import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RevenueByDayCard } from '@app/feature/statistics/revenue-section/cards/revenue-by-day.card';
import { RevenueByLocationCard } from '@app/feature/statistics/revenue-section/cards/revenue-by-location.card';
import { RevenueByMonthCard } from '@app/feature/statistics/revenue-section/cards/revenue-by-month.card';
import { RevenueByThirdPartyEndpointCard } from '@app/feature/statistics/revenue-section/cards/revenue-by-third-party-endpoint.card';
import {
  StatisticsAreaGranularityEnum,
  StatisticsTimeGranularityEnum,
} from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetRevenueQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import { useFilters } from '../context/filters.context';
import * as css from '../statistics.module.scss';
import { MoreLessRevenueChargePointCard } from './cards/more-less-revenue-charge-point.card';
import { RevenueByConnectorTypeCard } from './cards/revenue-by-connector-type.card';
import { RevenueCard } from './cards/revenue.card';

export const RevenueSectionComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const {
    transformedFilters,
    filters: { areaGranularity, timeGranularity },
  } = useFilters();

  const { data: revenue } = useCpmsBoGetRevenueQuery({
    ...transformedFilters,
  });

  const renderTitle = () => (
    <div className={css.accordionTitle}>
      <AccentTitle
        as={HeadingEnum.H2}
        icon="currency-euro-circle"
        text={t('$.statistics.revenue.title')}
        variant={AccentVariantEnum.Accent1}
      />
      <div className={classNames(css.revenue, css.count)}>
        <Stack direction="row" gap={GapEnum.XXS}>
          <NumberFixed
            bold
            fontSize={TextFontSize.Inherit}
            number={revenue?.total ?? 0}
            digits={0}
          />
          <Text bold>{t('$.statistics.revenue.revenue.total-unit')}</Text>
        </Stack>
      </div>
    </div>
  );

  return (
    <Accordion
      title={renderTitle()}
      isOpen={isOpen}
      onToggle={() => setIsOpen(true)}>
      <Stack gap={GapEnum.L} direction="column">
        <Stack gap={GapEnum.XL}>
          <RevenueCard />
          <MoreLessRevenueChargePointCard />
        </Stack>
        <Stack gap={GapEnum.XL}>
          {areaGranularity !== StatisticsAreaGranularityEnum.Location &&
            areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint && (
              <RevenueByLocationCard />
            )}
          {timeGranularity === StatisticsTimeGranularityEnum.Month ? (
            <RevenueByDayCard />
          ) : (
            <RevenueByMonthCard />
          )}
        </Stack>
        <Stack gap={GapEnum.XL}>
          <RevenueByThirdPartyEndpointCard />
          <RevenueByConnectorTypeCard />
        </Stack>
      </Stack>
    </Accordion>
  );
};
